export const APP_ENV = {
  development: 'development',
  production: 'production'
}
